import { COMMON_LABELS } from "../default-constants";

//各種ラベル
export const LABELS = {
  CORP_GW_CODE: "GWコード",
  CORP_GW_NAME: "GW名",
  CORP_GW_SERVICE: "契約サービス",
  CORP_GW_SERVICE_BARCODE: "バーコード",
  CORP_GW_SERVICE_NET: "ネット",
  CORP_GW_SERVICE_MINI: "ミニアプリ",
  CORP_GW_STATUS: "契約ステータス",
  STATUS_AGREE: "契約中",
  STATUS_STOP: "停止中",
  CORP_GW_START_DATE: "申込開始日",
  CORP_GW_CONTRACTED_USAGE_RATE: "契約利用料率合意内容",
  CORP_GW_ACCOUNT_INFO_MANAGEMENT: "口座情報管理要否",
  CORP_GW_IPID_ADVANCE_PAYMENT: "IPID事前払出要否",
  CORP_GW_BANK_NAME: "金融機関名",
  CORP_GW_BANK_CORD: "金融機関コード",
  CORP_GW_BANK_NUM: "口座番号",
  NECESSARY: "要",
  UNNECESSARY: "不要",
  CORP_GW_OK: "OK",
  CORP_GW_RETURN: "戻る",
  CORP_GW_CANCEL: "キャンセル",
  CORP_GW_UPDATE: "更新",
  CORP_GW_REG: "登録",
  GW_TITLE: "確認",
  CORPORATE_NUMBER: "法人番号",
  COMPANY_CODE: "事業者コード",
  COMPANY_NAME: "事業者名",
  GW_NAME_SMP: "（記入例）▲▲ペイメント",
  COMPANY_INFO_LABEL: "事業者情報",
  CONTRACT_INFO_LABEL: "契約内容",
} as const;

// プレースホルダーの内容
export const PLACE_HOLDERS = {
  CORP_CODE: COMMON_LABELS.BLANK,
  CORP_NUMBER: "法人番号検索をしてから必要情報を入力してください。",
  CORP_NAME: "（記入例）株式会社NTTドコモ",
  CORP_KANA: "（記入例）カブシキガイシャエヌティティドコモ",
} as const;
